module.exports = __webpack_public_path__ + "static/media/avlsanbefaling.b0913a8c.png";